import 'dayjs/locale/pt-br';

import dayjs, { Dayjs } from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.locale('pt-BR');
dayjs.extend(localeData);
dayjs.extend(relativeTime);

class DateFormat {
  static datetime(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('DD/MM/YYYY HH:mm');
  }

  static fromNow(datetime: Date | Dayjs): string {
    return dayjs(datetime).fromNow();
  }

  static date(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('DD/MM/YYYY');
  }

  static shortDate(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('DD/MM');
  }

  static mothYear(datetime: Date | Dayjs): string {
    return dayjs(datetime, 'DD/MM/YYYY').format('MM/YYYY');
  }

  static time(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('HH:mm');
  }

  static getShortMonth(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('MMM').toUpperCase();
  }

  static getMonth(datetime: Date | Dayjs): string {
    return dayjs(datetime).format('MMMM').toUpperCase();
  }
}

export default DateFormat;
